import React from 'react'
import './ResumeEntry.css'

export type ResumeEntryObject = {
    title: string;
    subtitle: string;
    startYear: number;
    endYear?: number;
    description: string;
}

const ResumeEntry: React.FC<ResumeEntryObject> = ({
    title,
    subtitle,
    startYear,
    endYear,
    description,
}) => {
    return (
        <div>
            <h4 className="header">{title}</h4>
            <div className="row mb-2">
                <div className="col-sm-auto">
                    <p className="subheader m-0">{subtitle}</p>
                </div>
                <div className="col p-sm-0">
                    <p className="m-0">{startYear} - {endYear}</p>
                </div>
            </div>
            <p>
                {description}
            </p>
        </div>
    )
}

export default ResumeEntry
